import AppListing from '../app-components/Listing/AppListing';

Vue.component('shift-plan-listing', {
  mixins: [AppListing],
  props: {
    'transMonths': {
      type: Object
    },
    'year': {
      type: Number
    },
    'month': {
      type: Number
    },
    'availableMonths': {
      type: Array
    },
    'availableYears': {
      type: Array
    },
  },

  data() {
    return {
      loading: false,
      employeesThisMonth: [],
      selectedEmployeeContract: {'last_name': '', 'first_name': '?'},
      loadingCalendar: true,
      days: [],
      selectedDates: {
        year: this.year,
        month: this.month
      }
    }
  },

  methods: {
    chooseMonth(year, month) {
      this.selectedDates.month = month;
      this.selectedDates.year = year;

      this.loadData();
    },

    loadData() {
    },

    loadEmployees() {
      axios.get('/shift-plans/employees/' + this.selectedDates.year + '/' + this.selectedDates.month)
        .then((res) => {
          if (res.data) {
            this.employeesThisMonth = res.data
            this.selectedEmployeeContract = res.data[0]
            this.loadPlans()
          }
        }).catch(console.log)
    },

    loadPlans() {
      this.loadingCalendar = true
      axios.get('/shift-plans/plans/' + this.selectedEmployeeContract.employee_contract_id + '/' + this.selectedDates.year + '/' + this.selectedDates.month)
        .then(res => {
          this.days = res.data
          this.loadingCalendar = false
        }).catch(console.log)
    }
  },

  created() {
    this.loadEmployees()
  },

  watch: {
    selectedEmployeeContract: function () {
      this.loadPlans()
    },
    'selectedDates': {
      handler: function () {
        window.history.replaceState({}, null, '/shift-plans/' + this.selectedDates.year + '/' + this.selectedDates.month);
        this.loadEmployees();
      },
      deep: true
    }
  }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/shift-plan/Listing.js